import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`


  query ($filmMasterID: ID!, $k: Int, $numCandidates: Int, $limit: Int, $offset: Int, $vectorNames: [String]) {
    StripSearcher(
      filmMasterID: $filmMasterID,
      k: $k,
      numCandidates: $numCandidates,
      limit: $limit,
      offset: $offset,
      vectorNames: $vectorNames
    ) {
      totalRows
      maxScore
      StripMatches {
        score
        FilmMaster {
          ...filmMasterDetail
          Film {
            ...filmDetail
            ...filmAwards
          }
        }
      }
    }
  }
  ${fragments.stripDetail}
  ${fragments.filmDetail}

  ${fragments.filmAwards}
  ${fragments.awardDetail}
  ${fragments.awardPrizeDetail}
  ${fragments.awardPrizeArtworks}
  ${fragments.artworkToArtifacts}

  ${fragments.filmMasterDetail}
  ${fragments.stripDetail}
  ${fragments.filmHost}
  ${fragments.filmMasterPosterFrames}
  ${fragments.artworkDetails}

  ${fragments.filmFiles}
  ${fragments.filmFileDetail}

`